module.exports = __webpack_public_path__ + "static/media/_ME11340.548adcaf.jpg";